export default __webpack_public_path__ + "static/media/icon-close-red.2ec9e4c1.jpg";